<template>
  <div class="form-group" :class="[containerClasses]">
    <label v-if="label !== null" :class="[labelClasses]">
      <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip!==null&&tooltipLeft&&!tooltipRight"></i>
      {{ label }}
      <span style="color:red">{{ required ? '*' : '' }}</span>
      <i class="m1" :class="[tooltipIcon]" :title="tooltip" v-if="tooltip!==null&&tooltipRight"></i>
    </label>
    <div 
      class="form-check" 
      :class="{'form-check-inline':checkInLine}" 
      v-for="(option, index) in input_options"
      :key="'radio-option-' + index">
      <input 
        type="radio"
        class="form-check-input"
        :class="[computedValidationStatus]"
        :id="'radio-option_' + index + '-' + _uid"
        v-model="cValue"
        :value="option.value"
        :disabled="disabled"
        :readonly="readOnly"
        @click="onClick"
        @focus="onFocus"
        @blur="onBlur"
        @keypress="onKeyPress"
      >
      <label class="form-check-label" :for="'radio-option_' + index + '-' + _uid">
        <template v-if="!hasSlotLabel">
          {{ option.label }}
        </template>
        <slot name="optionLabel" :option="option"></slot>
      </label>
    </div>
    <small class="form-text text-muted" v-if="helpText">{{ helpText }}</small>
    <div class="valid-feedback" v-if="computedValidationStatus == 'is-valid'" style="display: block !important;">
      <ul>
        <li v-for="(text, index) in validText" :key="_uid+'success_' + index">{{ text }}</li>
      </ul>
    </div>
    <div class="invalid-feedback" v-if="computedValidationStatus == 'is-invalid'" style="display: block !important;">
      <ul>
        <li v-for="(text, index) in invalidText" :key="_uid + 'error_' + index">{{ text }}</li>
      </ul>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import Vuex from 'vuex'
import {selectorMixin} from './../mixins/index.js';

export default {
  name: "single-select-radio",
  mixins: [selectorMixin],
  props: {
    value: {},
    required: {
      type: Boolean,
      default: false
    },
    checkInLine: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: null
    },
    tooltipIcon: {
      type: String,
      default: 'fas fa-question-circle'
    },
    tooltipRight: {
      type: Boolean,
      default: false
    },
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    disabled:{
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    options: {
      default: () => []
    },
    optionValue: {
      type: String,
      default: null
    },
    optionLabel: {
      type: String,
      default: null
    },
    optionFilter: {
      default: null
    }
  },
  watch: {
    value: function(newVal, oldVal){
      if(JSON.stringify(newVal) != JSON.stringify(this.cValue)){
        this.cValue = JSON.parse(JSON.stringify(newVal));
      }
    },
    cValue: function(newVal, oldVal){
      this.$emit('input', newVal);
      this.$emit('onChange', this);
    }
  },
  computed: {
    input_options() {
      try {
        let options = this.providerOptions.map((option, index) => {
          let adittionalParams = {enabled: typeof option.__enabled!=='undefined'?option.__enabled:true, index: index};
          if (typeof option === 'object' && (option.value != undefined && option.label != undefined)) {
            return {...option, ...adittionalParams};
          } else if (typeof option === 'object' && (this.optionLabel !== null && this.optionValue !== null)) {
            return {value: option[this.optionValue], label: option[this.optionLabel], ...adittionalParams};
          } else {
            return {value: option, label: option, ...adittionalParams};
          }
        });
        return options;
      } catch (err) {
        return [];
      }
    },
    hasSlotPrefix() {
      return !!this.$slots.prefix;
    },
    hasSlotSuffix() {
      return !!this.$slots.suffix;
    },
    slotClasses() {
      return this.hasSlotPrefix ? 'input-group-prepend' : this.hasSlotSuffix ? 'input-group-append' : null;
    },
    hasSlotLabel() {
      return !!this.$slots.optionLabel;
    }
  },
  mounted(){
    this.selectedOption = this.input_options.filter(o => o.value == this.value)[0];
    this.$emit('onMounted', this);
  },
  methods: {
    onClick(option) {
      this.selectedOption = option;
      //this.$emit('input', option.value);
      this.$emit('onclick', this);
    },
    onKeyPress() {
      this.$emit('onKeyPress', this);
    },
    onBlur() {
      this.$emit('onBlur', this);
    },
    onFocus() {
      this.$emit('onFocus', this);
    }
  },
  data() {
    return {
      cValue: this.value ? JSON.parse(JSON.stringify(this.value)) : null,
      selectedOption: null
    }
  }
}

</script>